import React, { Component } from "react";

import Landing from "./Landing";
import BelowLanding from "./BelowLanding";
import Services from "./Services";
import LocationSection from "./LocationSection";
import Reviews from "./Reviews";
import Footer from "./Footer";

import "../css/Home.css";

class Home extends Component {
  constructor(props) {
    super(props);

    this.reverse = true;
  }

  render() {
    return (
      <div className='page'>
        <div id='render' />
        <Landing />
        <BelowLanding />
        <Services {...this.props} />
        <LocationSection {...this.props} />
        <Reviews {...this.props} />
        <Footer />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js